<template>
    <div>
      <!-- modal -->
      <b-modal
        id="nationalTrademarkCountryShowHistoryListFormModal"
        centered
        size="lg"
        no-close-on-backdrop
        ref="nationalTrademarkCountryShowHistoryListFormModal"
        :title="this.transportToCountryName"
        hide-footer
      >
        <national-trademark-history-list :transportToCountryName="transportToCountryName" :nationalTrademarkCountryId="nationalTrademarkCountryId" :getNationalTrademarkList="getNationalTrademarkList" :getNationalTrademarkCountryList="getNationalTrademarkCountryList"></national-trademark-history-list>
      </b-modal>
    </div>
  </template>
  <script>

  export default {
    props: { 
        getNationalTrademarkCountryList: {type: Function},
        getNationalTrademarkList: {type: Function},
        transportToCountryName: String
    },
    data() {
      return {
        id: 0,
        nationalTrademarkCountryId: 0,
        nationalTrademarkCountryAgentOption: [],
        agentReferenceNo: '',
      }
    },
    methods: {
      showInfo(id){
        this.$refs['nationalTrademarkCountryShowHistoryListFormModal'].show()
        this.nationalTrademarkCountryId = id
      }
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
  